// skipcq: JS-W1028, JS-0128
import React from 'react';
import Stack from '@mui/material/Stack';
import useSplatAwardMonthlyReports from '../../hooks/useSplatAwardMonthlyReports';
import useUserCohortDailyReports from '../../hooks/useUserCohortDailyReports';
import DashboardMetricPanel from './DashboardMetricPanel';
import SplatMonthlyEarnedChart from './SplatMonthlyEarnedChart';
import UserCohortTrendChart from './UserCohortTrendChart';
import BeerActivityByStateCard from './BeerActivityByStateCard';
import FirstTouchHotspotsCard from './FirstTouchHotspotsCard';
import WorkQueueCountersRow from './WorkQueueCountersRow';

/**
 * Engage dashboard key metrics: live work-queue counters plus rollup-backed charts.
 */
function KeyMetricsCard() {
  const { rows, loading, error } = useSplatAwardMonthlyReports();
  const {
    chartRowsAscending,
    loading: cohortLoading,
    error: cohortError,
  } = useUserCohortDailyReports();

  return (
    <Stack spacing={3}>
      <WorkQueueCountersRow />
      <FirstTouchHotspotsCard />
      <BeerActivityByStateCard />

      <DashboardMetricPanel
        title="User cohorts"
        infoContent={
          <>
            Mutually exclusive registered-user cohorts · trailing 30-day activity window per
            snapshot · last 28 snapshot days shown · US Eastern midnight · from{' '}
            <code>userCohortReports</code>. Brewery favorites and anonymous app users are planned
            for a later release.
          </>
        }
      >
        <UserCohortTrendChart
          chartRowsAscending={chartRowsAscending}
          loading={cohortLoading}
          error={cohortError}
        />
      </DashboardMetricPanel>

      <DashboardMetricPanel
        title="Splats earned by month"
        infoContent={
          <>
            How well is the Beer Journey driving usage and adoption? UTC calendar months from
            awarded splat records.
          </>
        }
      >
        <SplatMonthlyEarnedChart rows={rows} loading={loading} error={error} />
      </DashboardMetricPanel>
    </Stack>
  );
}

export default KeyMetricsCard;
